/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function getListKhieuNaiApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getListComplainPath, {params: payload});
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postCreateKhieuNaiApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postCreateComplainPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getDetailKhieuNaiApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.getDetailComplainPath}/${payload}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postCloseKhieuNai(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postCloseComplainPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postReplyKhieuNaiApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postReplyComplainPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postUpdateKhieuNaiApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postUpdateComplainPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getListKhieuNaiByUserApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getListComplainByUserPath, {params: payload});
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}
